import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { ActiveSwaps } from '../../components/ActiveSwaps';
import { ContractComponent } from '../../components/ContractComponent';
import { GasRefuelMessage } from '../../components/GasMessage';
import { SelectChainAndToken } from '../../components/SelectChainAndToken';
import { SendToWallet, SendToWalletButton, } from '../../components/SendToWallet';
import { SwapInput } from '../../components/SwapInput';
import { SwapRoutes } from '../../components/SwapRoutes';
import { useExpandableVariant } from '../../hooks';
import { useWidgetConfig } from '../../providers';
import { MainGasMessage } from './MainGasMessage';
import { FormContainer } from './MainPage.style';
import { MainSwapButton } from './MainSwapButton';
export const MainPage = () => {
    const expandable = useExpandableVariant();
    const { variant } = useWidgetConfig();
    const nft = variant === 'nft';
    return (_jsxs(FormContainer, { disableGutters: true, children: [_jsx(ActiveSwaps, { mx: 3, mt: 1, mb: 1 }), nft ? _jsx(ContractComponent, { mx: 3, mt: 1, mb: 1 }) : null, _jsx(SelectChainAndToken, { mt: 1, mx: 3, mb: 2 }), !nft ? _jsx(SwapInput, { formType: "from", mx: 3, mb: 2 }) : null, !expandable ? _jsx(SwapRoutes, { mx: 3, mb: 2 }) : null, _jsx(SendToWallet, { mx: 3, mb: 2 }), _jsx(GasRefuelMessage, { mx: 3, mb: 2 }), _jsx(MainGasMessage, { mx: 3, mb: 2 }), _jsxs(Box, { display: "flex", mx: 3, mb: 1, children: [_jsx(MainSwapButton, {}), _jsx(SendToWalletButton, {})] })] }));
};
